import React from 'react';

const Card = ({ title, content, bgColor, textColor }) => {
  return (
    <div className={`rounded-xl py-5 ${bgColor}`}>
      <h1 className={`text-center text-2xl ${textColor}`}>{title}</h1>
      <p className={`px-10 text-justify text-xl py-5 ${textColor}`}>{content}</p>
    </div>
  );
};

export default Card;
